import { PropertyType } from 'lane-shared/types/properties/Property';

const REQUIRED_VALIDATOR_NAME = 'Required';
const BOOLEAN_QUESTION_TYPE = 'Boolean';

export function isCustomQuestionRequired(question: PropertyType): boolean {
  return Boolean(
    question.validators?.some(
      validator => validator.name === REQUIRED_VALIDATOR_NAME && validator.value === true
    )
  );
}

export function isBooleanCustomQuestion(question: PropertyType): boolean {
  return question.type === BOOLEAN_QUESTION_TYPE;
}

export function isBlankAnswer(answer?: string | null): boolean {
  return !answer || answer.trim().length === 0;
}
